export const fetchExtraFields = route => {
  return fetch(route, {
    method: "POST"
  })
    .then(response => response.json())
    .catch(e => {
      console.log(e);
    });
};
